<template>
  <div id="app">
    <!-- <Header></Header> -->
    <router-view />
  </div>
</template>

<script>
// import Header from "./components/Header";
export default {
  name: "App",
  // components: { Header },
  beforeCreate() {
    localStorage.setItem("locale", "en");
  },
  methods: {},
  mounted() {
    // this.isMobile()
    // if(this.isMobile) {
    //     alert("移动端");
    // }else {
    //     alert("pc端");
    // }
  },
};
</script>

<style lang="less">
#app {
  font-family: 微软雅黑, MicrosoftYaHei !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #ffffff;
}
body,
html {
  padding: 0;
  margin: 0;
}
.opc0 {
  opacity: 0;
}
.opc1 {
  opacity: 1;
}
.delay1 {
  -webkit-animation-delay: 0.3s; //延迟
  animation-delay: 0.3s;
}
.delay2 {
  -webkit-animation-delay: 0.6s; //延迟
  animation-delay: 0.6s;
}
.delay3 {
  -webkit-animation-delay: 0.9s; //延迟
  animation-delay: 0.9s;
}
.delay4 {
  -webkit-animation-delay: 1.2s; //延迟
  animation-delay: 1.2s;
}
.delay5 {
  -webkit-animation-delay: 1.5s; //延迟
  animation-delay: 1.5s;
}
.delay6 {
  -webkit-animation-delay: 1.8s; //延迟
  animation-delay: 1.8s;
}
.delay7 {
  -webkit-animation-delay: 2.1s; //延迟
  animation-delay: 2.1s;
}
.delay8 {
  -webkit-animation-delay: 2.4s; //延迟
  animation-delay: 2.4s;
}
/*::-webkit-scrollbar-track {*/
/*  border-radius: 10px;*/
/*  background-color: rgba(0,0,0,0.1);*/
/*  border: none !important;*/

/*}*/

/*!*定义滑块 内阴影+圆角*!*/

/*::-webkit-scrollbar-thumb*/

/*{*/
/*  border: none !important;*/
/*  border-radius: 10px;*/
/*  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);*/
/*  background-color: rgba(0,0,0,0.1);*/

/*}*/
html {
  overflow-y: scroll;
}

:root {
  overflow-y: auto;
  overflow-x: hidden;
}

:root body {
  position: absolute;
}

body {
  width: 100vw;
  overflow: hidden;
}
</style>
